const ResponseCode = {
  BAD_REQUEST: {
    code: 400,
    message: 'Parametros enviados incorrectos.',
  },
  NOT_FOUND: {
    code: 404,
    message: 'Registros no encontrados.',
  },
  CONTENT_TOO_LARGE: {
    code: 413,
    message: 'Contenido muy largo',
  },
  CONNECTION_ERROR: {
    code: 600,
    message: 'Error en la conexión de internet.',
  },
  NETWORK_ERROR: {
    code: 503,
    message: 'No se pudo comunicar con el servidor.',
  },
  TIMEOUT_ERROR: {
    code: 504,
    message: 'Ha excedido el tiempo de respuesta.',
  },
  SERVER_ERROR: {
    code: 500,
    message:
      'En este momento no es posible establecer una comunicación con el servidor, favor intentar más tarde.',
  },
  NO_DATA: {
    code: 501,
    message: 'Aún no existen datos.',
  },
  UNAUTHORIZED: {
    code: 401,
    message: 'Unauthorized',
  },
  OK: {
    code: 200,
    message: 'OK',
  },
};

export default ResponseCode;
